export default {
  translations: {
    'Try it out': 'Essayer',
    'Preview not available': 'Aperçu non disponible',
    'New Board': 'Nouveau tableau',
    'Import from .zip': 'Importer un .zip',
    'Importing...': 'Importation...',
    'Failed to import board.': "Échec de l'importation de la planche.",
    'Create board on the tablet?': 'Créer la planche sur la tablette ?',
    'Import board to the tablet?': 'Importer la planche sur la tablette ?',
    "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.":
      'Cette planche sera créée dans la sauvegarde de la tablette de cet utilisateur, et non dans vos planches du Portail. Elle sera envoyée à la tablette lors de la prochaine synchronisation.',
    'Board title': 'Titre du tableau',
    'Enter a title for the board': 'Saisissez un titre pour le tableau',
    'Card language': 'Langue de la carte',
    'Creating...': 'Création...',
    'Failed to create board.': 'Échec de la création du tableau.',
    'Choose an image from the bank, generate one with AI or upload your own.':
      "Choisissez une image dans la banque, générez-en une avec l'IA ou importez la vôtre.",
    'Used for the symbol bank and speech (text-to-speech) of this board.':
      'Utilisé pour la banque de symboles et la voix (synthèse vocale) de ce tableau.',
    'How do you want to start?': 'Comment voulez-vous commencer ?',
    'Blank board': 'Tableau vierge',
    'Start with tutorial': 'Commencer avec le tutoriel',
    'Create a board from scratch': 'Créez un tableau à partir de zéro',
    'Learn the studio with a ready-made board':
      "Apprenez le studio avec un tableau prêt à l'emploi",
    'Is this your first time creating boards?':
      'Est-ce votre première création de tableaux ?',
    "Don't show this again": 'Ne plus afficher',
    'Choose a title for your board': 'Choisissez un titre pour votre tableau',
    'Preview board': 'Aperçu du tableau',
    'Displayed text': 'Texte affiché',
    'Back and edit': 'Retour et modification',
    SMALL: 'Petit',
    MEDIUM: 'Moyen',
    LARGE: 'Grand',
    login: {
      welcome: 'Bienvenue chez Livox!',
      error:
        'Impossible de se connecter avec les informations fournies. E-mail et/ou mot de passe incorrect(s).',
      inactive_customer:
        "Votre compte a été désactivé. Veuillez contacter le support pour obtenir de l'aide.",
    },
    payment: {
      purchaseFor: 'Achat pour',
      supportEmail: 'E-mail de contact',
    },
    pm: {
      cards: 'Cartes',
      manageYourPayment:
        'Gérez vos informations de paiement. Pour voir les détails de votre abonnement mensuel, allez à Abonnements.',
      defaultPayment: 'Paiement par défaut',
      setAsDefault: 'Définir comme par défaut',
      addCard: 'Ajouter une carte',
      addBoleto: 'Ajouter un boleto',
      creditCard: 'Carte de Crédit',
      boleto: 'Boleto',
      add: 'Ajouter',
      boletos: 'Boletos',
    },
    paymentRegister: {
      title: 'Inscrivez-vous pour acheter Livox',
      orLoginWithAccount: 'Vous avez déjà un compte ?',
      loginToComplete: 'Connectez-vous pour finaliser votre achat',
      orRegisterNew: 'Ou inscrivez-vous pour créer un nouveau compte',
      holderAlreadyRegistered:
        'Un titulaire est déjà enregistré avec cet e-mail. Veuillez vous connecter au portail.',
      holderAlreadyRegisteredTitle: 'Titulaire déjà enregistré',
      holderAlreadyRegisteredMessage:
        'Un titulaire est déjà enregistré avec cet e-mail. Veuillez vous connecter au portail pour accéder à votre compte.',
      holderAlreadyRegisteredMessageWithEmail:
        "Un titulaire est déjà enregistré avec cet e-mail. L'e-mail {{email}} a déjà été créé comme titulaire. Veuillez vous connecter au portail pour accéder à votre compte.",
      goToLogin: 'Aller à la connexion',
    },
    Role: 'Rôle',
    Often: 'Fréquemment',
    Sometimes: 'Parfois',
    Never: 'Jamais',
    Date: 'Date',
    CGQ: 'CGT',
    VIQ: 'VIS',
    AUQ: 'AUD',
    OLQ: 'CLO',
    BHQ: 'CMP',
    Overall: 'Général',
    Actions: 'Actions',
    'Holder Info': 'Informations du Titulaire',
    Loading: 'Chargement',
    Profile: 'Profil',
    Comments: 'Commentaires',
    'View Branch': 'Voir la Succursale',
    'Add License to Branch': 'Ajouter une licence à la succursale',
    'Create Board': 'Créer un tableau',
    'Review Publication': 'Revoir la publication',
    Creator: 'Créateur',
    'Board History': 'Historique des tableaux',
    'Change Customers to Support Area':
      'Changer les clients en zone de support',
    'Change Users to Support Area':
      'Changer les utilisateurs en zone de support',
    'Change Licenses to Branch': 'Changer les licences en succursale',
    'Tablet code': 'Code de la tablette',
    Back: 'Retour',
    'Livox Store': 'Magasin Livox',
    Communication: 'Communication',
    Leisure: 'Loisirs',
    Feelings: 'Sentiments',
    Hospital: 'Hôpital',
    Social: 'Social',
    'Daily Life': 'Vie quotidienne',
    Foods: 'Alimentation',
    School: 'École',
    Education: 'Éducation',
    Literacy: 'Alphabétisation',
    Grammar: 'Grammaire',
    Geography: 'Géographie',
    Science: 'Sciences',
    History: 'Histoire',
    Math: 'Mathématiques',
    Biology: 'Biologie',
    Fun: 'Amusement',
    Stories: 'Histoires',
    Games: 'Jeux',
    Game: 'Jeu',
    Memory: 'Mémoire',
    'Questions and Answers': 'Questions et Réponses',
    'Popular Items': 'Articles populaires',
    'See more': 'Voir plus',
    Code: 'Code',
    'Last Modified': 'Dernière modification',
    'Upload from .zip': 'Télécharger depuis .zip',
    'My Boards': 'Mes tableaux',
    'My Portal Boards': 'Mes Tableaux du Portail',
    'Welcome {{name}}, you have {{count}} licenses':
      'Bienvenue {{name}}, vous avez {{count}} licences',
    'Publish one of your boards to share it with the Livox community.':
      'Publiez un de vos tableaux pour le partager avec la communauté Livox.',
    'Welcome {{name}}, you have {{count}} users':
      'Bienvenue {{name}}, vous avez {{count}} utilisateurs',
    'A-Z': 'A-Z',
    Size: 'Taille',
    Studio: 'Studio',
    Favorites: 'Favoris',
    Keyboard: 'Clavier',
    Import: 'Importer',
    Assign: 'Attribuer',
    'Cover Art': 'Illustration de couverture',
    Title: 'Titre',
    Description: 'Description',
    Categories: 'Catégories',
    Submitter: 'Soumettant',
    'Published at': 'Publié le',
    View: 'Voir',
    'Pending Approval': "En attente d'approbation",
    'Holders Search': 'Recherche de titulaires',
    'Filter Status': 'Filtrer le statut',
    'Audit Licenses': 'Auditer les licences',
    'No Device': "Pas d'appareil",
    'Livox Version': 'Version de Livox',
    'Android Version': 'Version Android',
    'Last Validation At': 'Dernière validation à',
    Manage: 'Gérer',
    Store: 'Magasin',
    Books: 'Livres',
    'Sign up': "S'inscrire",
    Talk: 'Parler',
    Learn: 'Apprendre',
    Admin: 'Admin',
    'Store Admin': 'Admin de la Boutique',
    'Discover new boards, games and stories':
      'Découvrez de nouveaux tableaux, jeux et histoires',
    'Search in store': 'Rechercher dans la boutique',
    'Search boards, games, stories...': 'Chercher tableaux, jeux, histoires...',
    'Recommended content': 'Contenu recommandé',
    'Featured boards': 'Tableaux en vedette',
    'New content': 'Nouveau contenu',
    'Featured creators': 'Créateurs en vedette',
    'Sort by': 'Trier par',
    Downloads: 'Téléchargements',
    'Livox Community': 'Communauté Livox',
    'Total downloads': 'Total des téléchargements',
    'Community content': 'Contenu de la communauté',
    Follow: 'Suivre',
    Following: 'Suivi',
    'View content': 'Voir le contenu',
    Community: 'Communauté',
    Logout: 'Se déconnecter',
    'No description': 'Aucune description',
    'No Title': 'Sans titre',
    New: 'Nouveau',
    'My content': 'Mes contenus',
    'Unable to load your content': 'Impossible de charger vos contenus',
    'Import board': 'Importer le tableau',
    'Created by': 'Créé par',
    'Board tags': 'Étiquettes du tableau',
    'No tags': 'Aucune étiquette',
    'Report content': 'Signaler le contenu',
    'Report reason': 'Motif du signalement',
    Report: 'Signaler',
    'Report sent': 'Signalement envoyé',
    'Failed to send report': 'Échec de l’envoi du signalement',
    'Offensive content': 'Contenu offensant',
    'Inappropriate language': 'Langage inapproprié',
    'Sexual or inappropriate content': 'Contenu sexuel ou inapproprié',
    Violence: 'Violence',
    'Hate speech': 'Discours haineux',
    'Spam or advertising': 'Spam ou publicité',
    'Copyright infringement': 'Violation du droit d’auteur',
    'Duplicate content': 'Contenu en double',
    'Off-topic content': 'Contenu hors sujet',
    'Exposed personal data': 'Données personnelles exposées',
    'Content deleted': 'Contenu supprimé',
    'Failed to delete content': 'Échec de la suppression du contenu',
    'Sending...': 'Envoi...',
    'New Releases': 'Nouveautés',
    'Top Rated': 'Mieux Notés',
    'See all': 'Voir tout',
    'Browse by category': 'Parcourir par catégorie',
    'No content found': 'Aucun contenu trouvé',
    'Try adjusting your filters': 'Essayez d’ajuster vos filtres',
    'Go to slide': 'Aller à la diapositive',
    'Back to Store': 'Retour à la Boutique',
    'Loading board...': 'Chargement de la publication...',
    'No description provided': 'Aucune description',
    stars: 'étoiles',
    votes: 'votes',
    Rate: 'Noter',
    'Be the first to rate': 'Soyez le premier à noter',
    'In progress': 'En cours',
    'Tablet preview': 'Aperçu sur tablette',
    'Tablet preview coming soon': 'Aperçu tablette à venir',
    Republish: 'Republier',
    Filters: 'Filtres',
    Clear: 'Effacer',
    Speak: 'Parler',
    Previous: 'Précédent',
    'Previous page': 'Page précédente',
    'Next page': 'Page suivante',
    'Remove last': 'Supprimer le dernier',
    Fullscreen: 'Plein écran',
    'Exit fullscreen': 'Quitter le plein écran',
    'Go to Portal': 'Aller au Portail',
    'Sign in': 'Se connecter',
    'Sign out': 'Se déconnecter',
    'Open menu': 'Ouvrir le menu',
    'Close menu': 'Fermer le menu',
    Menu: 'Menu',
    'Publication not available': 'Cette publication n’est pas disponible',
    'All languages': 'Toutes les langues',
    'Switch to dark mode': 'Passer en mode sombre',
    'Switch to light mode': 'Passer en mode clair',
    'Toggle theme': 'Changer de thème',
    'Sign in to download': 'Connectez-vous pour télécharger',
    'Sign in to rate': 'Connectez-vous pour noter',
    'Author not found': 'Auteur introuvable',
    'Unnamed author': 'Auteur sans nom',
    publication: 'publication',
    publications: 'publications',
    'Boards by this author': 'Tableaux de cet auteur',
    'Link copied to clipboard': 'Lien copié dans le presse-papiers',
    'Failed to download content': 'Échec du téléchargement',
    'Download started': 'Téléchargement démarré',
    'Thanks for your vote!': 'Merci pour votre vote !',
    'Failed to send vote': 'Échec de l’envoi du vote',
    'Content promoted': 'Contenu mis en avant',
    'View profile': 'Voir le profil',
    'Page Size': 'Taille de la page',
    'Licenses Search': 'Recherche de Licences',
    Licenses: 'Licences',
    'Stripe Information': 'Informations Stripe',
    'No information': "Pas d'informations",
    Canceled: 'Annulé',
    past_due: 'Paiement en retard',
    active: 'Activé',
    'Support Areas': 'Zones de Support',
    Customers: 'Clients',
    'Livox Users': 'Utilisateurs Livox',
    'Distributor Totals': 'Statistiques du distributeur',
    'Portal Administration': 'Administration du Portail',
    'My Devices': 'Mes Appareils',
    'My Livox Users': 'Mes Utilisateurs Livox',
    'My Licenses': 'Mes Licences',
    'My Authorized Users': 'Mes Utilisateurs Autorisés',
    'New Customer': 'Nouveau Client',
    'Notify Customer': 'Notifier le Client',
    'New Branch': 'Nouvelle Succursale',
    'New Portal User': 'Nouvel Utilisateur du Portail',
    'Install Key': "Clé d'installation",
    'License Key': 'Clé de Licence',
    'New License': 'Nouvelle Licence',
    'New Registration Link': "Créer un lien d'activation",
    'All Livox users': 'Tous les Utilisateurs Livox',
    Home: 'Accueil',
    Customer: 'Client',
    'My Branches': 'Mes Succursales',
    Branches: 'Succursales',
    'Last Name': 'Nom de famille',
    Gender: 'Genre',
    Age: 'Âge',
    Evaluations: 'Évaluations',
    'Last Evalution': 'Dernière Évaluation',
    License: 'Licences',
    Key: 'Clé',
    Status: 'Statut',
    City: 'Ville',
    State: 'État',
    Country: 'Pays',
    Available: 'Disponible',
    Active: 'Activé',
    Inactive: 'Inactif',
    Phone: 'Téléphone',
    'First Name': 'Prénom',
    'Device Name': "Nom de l'Appareil",
    Version: 'Version',
    'Remove Device': "Supprimer l'Appareil",
    User: 'Utilisateur',
    Contact: 'Contact',
    Diagnosis: 'Diagnostic',
    Device: 'Appareil',
    'Delete User': "Supprimer l'Utilisateur",
    'My Users': 'Utilisateur de Livox',
    Expire: "Date d'expiration",
    Support: 'Support',
    Dates: 'Dates',
    'Expiration Date': "Date d'Expiration",
    'Support Date': 'Date de Support',
    'Click to edit expiration date':
      "Cliquez pour modifier la date d'expiration",
    'Click to edit support date': 'Cliquez pour modifier la date de support',
    'Expiration date updated successfully':
      "Date d'expiration mise à jour avec succès",
    'Support date updated successfully':
      'Date de support mise à jour avec succès',
    'Failed to update expire date':
      "Échec de la mise à jour de la date d'expiration",
    'Failed to update support date':
      'Échec de la mise à jour de la date de support',
    'MAC Address': 'Adresse MAC',
    'Device Version': "Version de l'appareil",
    Name: 'Nom',
    'Num. Licenses': 'Num. Licences',
    Activated: 'Activé',
    Inactivated: 'Désactivé',
    Email: 'E-mail',
    'My Auth Users': 'Mes Utilisateurs Autorisés',
    Holder: 'Titulaire',
    'Customer Licenses': 'Licences du Client',
    Type: 'Type',
    Distribution: 'Distributeur',
    Language: 'Langue',
    Reseller: 'Revendeur',
    Text: 'Texte',
    'Number of Devices': "Nombre d'appareils",
    'Lifetime License': 'Licence à vie',
    Address: 'Adresse',
    Zipcode: 'Code postal',
    Neighborhood: 'Quartier',
    'Contact Email': 'E-mail de contact',
    'Confirm Contact Email': "Confirmer l'e-mail de contact",
    'First name': 'Prénom',
    'Last name': 'Nom de famille',
    Group: 'Groupe',
    Password: 'Mot de passe',
    Male: 'Masculin',
    Female: 'Féminin',
    'My Portal Users': 'Mes Utilisateurs du Portail',
    'Edit Profile': 'Éditer le Profil',
    'Change Password': 'Changer le mot de passe',
    Register: "S'inscrire",
    'I forgot my password': "J'ai oublié mon mot de passe",
    Account: 'Compte',
    'No results': 'Pas de résultats',
    'Customers Search': 'Recherche de Clients',
    Search: 'Rechercher',
    'Search by name or email': 'Rechercher par nom ou e-mail',
    'Tree view': 'Vue arborescente',
    'Table view': 'Vue tableau',
    Download: 'Télécharger',
    'Registration Link': "Lien d'Inscription",
    Page: 'Page',
    of: 'de',
    results: 'résultats',
    'View Branches': 'Voir les Succursales',
    'View Users': 'Voir les Utilisateurs',
    Cancel: 'Annuler',
    Create: 'Créer',
    'Branch Name': 'Nom de la succursale',
    'Confirm Password': 'Confirmer le mot de passe',
    'Customer Branches': 'Succursales du Client',
    'My Evaluations': 'Mes évaluations',
    'Livox User': 'Utilisateur de Livox',
    'Add Branch': 'Ajouter une Succursale',
    'Distributor Customers': 'Clients du distributeur',
    'New Support Area': 'Nouvelle zone de support',
    'Assign Users': 'Attribuer les utilisateurs',
    'Assign Customers': 'Attribuer les clients',
    Dashboard: 'Tableau de bord',
    'Unique users by day': 'Utilisateurs uniques par jour',
    'Users by language': 'Utilisateurs par langue',
    'Users by country': 'Utilisateurs par pays',
    Devices: 'Appareils',
    'Manage my devices': 'Gérer mes appareils',
    News: 'Actualités',
    'Read more': 'Lire plus',
    'Total Licenses': 'Total des Licences',
    'Paid Licenses': 'Licences Payées',
    'Free Licenses': 'Licences Gratuites',
    'Distributor Stats': 'Statistiques du Distributeur',
    Users: 'Utilisateurs',
    Remove: 'Supprimer',
    Evaluate: 'Évaluer',
    'Cognitive Evaluation': 'Évaluation Cognitive',
    'Recognizes images': 'Reconnaît les images',
    'Notion of cause and effect': 'Notion de cause à effet',
    'Has notion of body awareness': 'A une notion de conscience corporelle',
    'Has symbolic representation': 'A une représentation symbolique',
    'Makes choices': 'Fait des choix',
    Literate: 'Lettré',
    'Auditory Agnosia': 'Agnosie Auditive',
    'Cow mooing': 'Vache meuglant',
    'Chicken clucking': 'Poulet caquetant',
    'Dog barking': 'Chien aboyant',
    Doorbell: 'Sonnette',
    Sirens: 'Sirènes',
    'Visual Agnosia': 'Agnosie Visuelle',
    Dog: 'Chien',
    Cat: 'Chat',
    Bird: 'Oiseau',
    House: 'Maison',
    Banana: 'Banane',
    Grapes: 'Raisin',
    Pineapple: 'Ananas',
    Watermelon: 'Pastèque',
    Telephone: 'Téléphone',
    Car: 'Voiture',
    Shoe: 'Chaussure',
    Ball: 'Balle',
    'Visual Oral Language': 'Langage Oral Visuel',
    'Where is the ball?': 'Où est la balle?',
    'Where is the doll?': 'Où est la poupée?',
    'Are you at home?': 'Es-tu à la maison?',
    'What is the name of your mother?': 'Quel est le nom de ta mère?',
    'What is your name?': 'Quel est ton nom?',
    'Does he/she know his/her birthday?':
      "Connaît-il/elle sa date d'anniversaire?",
    'Does he/she know his/her name?': 'Connaît-il/elle son nom?',
    'Does he/she orient to date/time?':
      "S'oriente-t-il/elle avec la date/heure?",
    'Can he/she follow one step directions?':
      'Peut-il/elle suivre des instructions en une étape?',
    'Can he/she follow two step directions?':
      'Peut-il/elle suivre des instructions en deux étapes?',
    'Behavior Evaluation': 'Évaluation du Comportement',
    'Does he/she bite?': 'Mord-il/elle?',
    'Does he/she hit his/her head on the wall?':
      'Se cogne-t-il/elle la tête contre le mur?',
    'Does he/she understand feelings?': 'Comprend-il/elle les sentiments?',
    'Does he/she sleep well?': 'Dort-il/elle bien?',
    General: 'Général',
    'Does he/she cry?': 'Pleure-t-il/elle?',
    'Does he/she have temper tantrums?': 'Fait-il/elle des crises de colère?',
    'Is he/she aggressive?': 'Est-il/elle agressif/ve?',
    'Does he/she eat well?': 'Mange-t-il/elle bien?',
    'Does he/she run from one place to another?':
      "Court-il/elle d'un endroit à un autre?",
    'Does he/she focus in an activity?':
      'Se concentre-t-il/elle sur une activité?',
    'Does he/she play with other children?':
      "Joue-t-il/elle avec d'autres enfants?",
    'Does he/she have a hard time to sleep?': 'A-t-il/elle du mal à dormir?',
    'Does he/she like to be alone?': 'Aime-t-il/elle être seul(e)?',
    'Does he/she demonstrate joint attention?':
      'Montre-t-il/elle une attention conjointe?',
    'Does he/she scream?': 'Crie-t-il/elle?',
    'Is he/she hypersensitive to sensory stimuli?':
      'Est-il/elle hypersensible aux stimuli sensoriels?',
    'Is he/she unaware to sensory stimuli?':
      'Est-il/elle insensible aux stimuli sensoriels?',
    Holders: 'Titulaires',
    Purcharse: 'Acheter',
    Edit: 'Éditer',
    Delete: 'Supprimer',
    'E-mail': 'E-mail',
    'Full Name': 'Nom complet',
    'Phone Number': 'Numéro de téléphone',
    Save: 'Enregistrer',
    Undo: 'Annuler',
    Publish: 'Publier',
    'New Item': 'Nouvel item',
    Attributes: 'Attributs',
    'Display Text': 'Texte à afficher',
    'Spoken Phrase': 'Phrase parlée',
    'Expand image on click': "Agrandir l'image au clic",
    Colors: 'Couleurs',
    Pictures: 'Images',
    'Search a symbol': 'Rechercher un symbole',
    'Field Changed': 'Champ modifié',
    'Old Value': 'Ancienne valeur',
    'New Value': 'Nouvelle valeur',
    'License History': 'Historique de la Licence',
    Branch: 'Succursale',
    'Evaluation Date': "Date d'Évaluation",
    'Branch Licenses': 'Licences de la Succursale',
    'Add Licenses to Branch': 'Ajouter des licences à la Succursale',
    Confirm: 'Confirmer',
    Close: 'Fermer',
    'Livox version distribution': 'Distribution par version de Livox',
    'Expires in': 'Expire dans',
    'Support ends': 'Le support se termine le',
    available: 'disponible',
    'Android OS distribution': 'Distribution par Version Android',
    likes: 'aime',
    downloads: 'téléchargements',
    'Reviewed at': 'Revu le',
    Comment: 'Commentaire',
    Pending: 'En attente',
    Approved: 'Approuvé',
    Archived: 'Archivé',
    Accept: 'Accepter',
    Reject: 'Rejeter',
    Reason: 'Raison',
    Rejected: 'Rejeté',
    'Create License Registration Link':
      "Créer un lien d'enregistrement de licence",
    'Create separate install keys': "Créer des clés d'installation séparées",
    'Log Out': 'Se Déconnecter',
    'Evaluate Livox User': "Évaluer l'utilisateur Livox",
    Billing: 'Facturation',
    'Acquire Livox': 'Acquérir Livox',
    'You are about to purchase the best alternative comunication app in the world!':
      "Vous êtes sur le point d'acheter la meilleure application de communication alternative au monde!",
    '1. Select a Plan': '1. Sélectionnez un Plan',
    BASIC: 'BASIC',
    'Up to 3 users': "Jusqu'à 3 utilisateurs",
    'Smart Scan': 'Scan Intelligent',
    'IntelliTouch - Touch Correction': 'IntelliTouch - Correction du Touch',
    'Virtual keyboard': 'Clavier Virtuel',
    'Stock Images (20,000 images)': "Banque d'images (+20 000 images)",
    'Creation of pedagogical content': 'Création de contenu pédagogique',
    'Voice, text and image customization':
      "Personnalisation de la voix, du texte et de l'image",
    'Content transfer between tablets': 'Transfert de contenu entre tablettes',
    '/ month': 'par mois',
    'on a yearly plan': 'sur un plan annuel',
    PLUS: 'PLUS',
    'Recommended for families': 'Recommandé pour les familles',
    'New Features Update': 'Mise à jour de nouvelles fonctionnalités',
    'Trigger Control': 'Contrôle par Déclencheur',
    'Livox control with the blink of an eye':
      "Contrôle de Livox avec un clin d'œil",
    'Artificially Intelligent Item Recommendations Based on Time and Location':
      "Recommandations d'articles basées sur l'heure et le lieu grâce à l'Intelligence Artificielle",
    PRO: 'PRO',
    'Recommended for professionals!': 'Recommandé pour les professionnels!',
    'UNLIMITED Users': 'Utilisateurs ILLIMITÉS',
    'Complete assessment and content tool to track users progress with Livox (patients or students)':
      "Outil d'évaluation complète et de contenu pour suivre les progrès des utilisateurs avec Livox (patients ou élèves)",
    '2. Select a payment plan': '2. Sélectionnez le plan de paiement',
    monthly: 'mensuel',
    quarterly: 'trimestriel',
    '% off': '% de réduction',
    yearly: 'annuel',
    '3. Confirm the value': '3. Confirmez la valeur',
    'per month': 'par mois',
    'Proceed with the checkout': "Poursuivre l'achat",
    'Select a Plan': 'Sélectionner un Plan',
    Continue: 'Continuer',
    'Get Livox': 'Obtenir Livox',
    'Select a Plan - Livox Portal': 'Choisir un Plan - Portail Livox',
    '1. Confirm your Plan': '1. Confirmez votre Plan',
    '3. Confirm the plan': '3. Confirmez le plan',
    Checkout: 'Valider',
    'Secure checkout': 'Paiement Sécurisé',
    'per year': 'par année',
    Change: 'Changer',
    'per quarter': 'par trimestre',
    'Cardholder Name': 'Nom du Titulaire de la Carte',
    'Street address': 'Adresse',
    'Apartment / Suite / Unit / Building':
      'Appartement / Suite / Unité / Bâtiment',
    'Billing Address': 'Adresse de Facturation',
    'Payment Info': 'Informations de Paiement',
    'Credit or debit card': 'Carte de crédit ou débit',
    'Credit card info secured by': 'Informations de carte protégées par',
    Success: 'Succès',
    'Upload from .zip file here': 'Télécharger un fichier .zip ici',
    'Published Title': 'Titre Publié',
    'Publish Content': 'Publier le Contenu',
    'Cover Image': 'Image de Couverture',
    'Upload Image': "Télécharger l'Image",
    Buy: 'Acheter',
    Boards: 'Tableaux',
    'Thanks for purchasing Livox': "Merci d'avoir acheté Livox",
    'We are processing your payment, a receipt will be sent to':
      'Nous traitons votre paiement, un reçu sera envoyé à',
    'with instructions on how activate Livox.':
      "avec des instructions sur la façon d'activer Livox.",
    'If you have any question / issues': 'Pour toute question/problème',
    'contact our support.': 'contactez notre support.',
    Deleted: 'Supprimé',
    'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.':
      "Vous avez soumis ce tableau pour examen avec succès, merci de patienter jusqu'à 48 heures pour l'approbation.",
    'You have successfully registered, Please return to the tablet to proceed.':
      'Vous vous êtes inscrit avec succès, veuillez retourner à la tablette pour continuer.',
    'Validation notEmpty on coverImage failed':
      'Veuillez ajouter une image à votre publication.',
    'You are not logged in. Create your account to see more of this content':
      "Vous n'êtes pas connecté. Créez votre compte pour voir plus de contenu.",
    'Buy Livox': 'Acheter Livox',
    'Select your plan and payment method to get started.':
      'Sélectionnez votre forfait et mode de paiement pour commencer.',
    'payment.pageDescription':
      "Sélectionnez votre forfait et votre mode de paiement pour finaliser l'achat.",
    'payment.propaganda':
      "Vous êtes sur le point d'acquérir la meilleure application de communication alternative au monde !",
    'payment.activeSubscriptionsCount': '{{count}} abonnement(s) actif(s)',
    'payment.youHaveLicenses': 'Vous avez des licences actives.',
    'payment.viewLicensesHere': 'Voir vos licences ici',
    'payment.youHaveActiveSubscriptions': 'Vous avez des abonnements actifs.',
    'payment.viewMyAssessments': 'Voir dans Mes évaluations',
    'payment.viewMySubscriptions': 'Voir dans Mes abonnements',
    'payment.onlyPortugueseTitle': 'Paiement indisponible',
    'payment.onlyPortugueseAvailable':
      "Le paiement n'est disponible qu'en portugais pour le moment.",
    'payment.blockedInBrazilTitle': 'Paiement indisponible dans votre région',
    'payment.blockedInBrazil':
      "Le paiement en ligne n'est pas disponible pour les accès depuis le Brésil.",
    'payment.blockedContactTitle': 'Contactez-nous :',
    'payment.blockedContactBrazil':
      'Brésil\n+55 81 97108 3009 (Téléphone et WhatsApp)\ncontato@livox.com.br\nAvenida Fagundes Varela, 950, LJ 15, CXP 1776, Jardim Atlântico, Olinda-Pe, Brésil, CEP: 53140-080',
    'payment.blockedContactUS':
      'États-Unis\n+1 (407) 449-6391\ncarlos@livox.com.br\nGrand National Drive, suite 128, Orlando, FL',
    'payment.blockedContactJordan':
      'Jordanie\n00962796870058\nala.alramahi@gmail.com',
    'payment.noLicensesEncourage':
      "Vous n'avez aucune licence. Achetez maintenant pour commencer avec Livox !",
    Media: 'Médias',
    'Upload an image or video': 'Télécharger une image ou une vidéo',
    'No image': "Pas d'image",
    'Welcome to your boards page': 'Bienvenue sur votre page de tableaux',
    'Assistive Technology': "Technologie d'Assistance",
    '1. Create': '1. Créer',
    'To get started use the Livox Studio to create cards, upload images, music and videos':
      'Pour commencer, utilisez Livox Studio pour créer des cartes, télécharger des images, de la musique et des vidéos',
    '2. Publish': '2. Publier',
    'Submit your content to be published in the store':
      'Soumettez votre contenu pour être publié dans le magasin',
    '3. Get feedback': '3. Obtenez des commentaires',
    'Receive feedback and satisfaction on seeing your content being used all around the globe!':
      'Recevez des commentaires et la satisfaction de voir votre contenu utilisé dans le monde entier!',
    'Livox Portal': 'Portail Livox',
    'A content store made for you!': 'Une boutique de contenu faite pour vous!',
    'The best portal of assistive technologies in the world!':
      "Le meilleur portail de technologies d'assistance au monde!",
    'Learn More': 'En savoir plus',
    'Recent Items': 'Articles Récents',
    by: 'par',
    'Untitled Content': 'Contenu sans titre',
    'Loading...': 'Chargement...',
    'Click here to add a title': 'Cliquez ici pour ajouter un titre',
    'Portuguese (BR)': 'Portugais (Brésil)',
    English: 'Anglais',
    Arabic: 'Arabe',
    German: 'Allemand',
    'No boards found': 'Aucun tableau trouvé',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this device?':
      "La suppression de cet appareil déconnectera l'utilisateur de l'application. Êtes-vous sûr de vouloir supprimer cet appareil?",
    'New User': 'Nouvel Utilisateur',
    'Login as another user': "Se connecter en tant qu'un autre utilisateur",
    Technical: 'Technique',
    Pedagogical: 'Pédagogique',
    Results: 'Résultats',
    'Top Rated Items': 'Articles les Mieux Notés',
    'Back to Livox Portal': 'Retour au Portail Livox',
    'No Categories': 'Aucune Catégorie',
    Author: 'Auteur',
    'No votes yet': 'Pas encore de votes',
    'Rate this content': 'Évaluez ce contenu',
    'You must be logged in to vote on this content!':
      'Vous devez être connecté pour voter sur ce contenu!',
    'Go to Livox Store': 'Aller à la Boutique Livox',
    'Go to Play Store': 'Aller sur le Play Store',
    'Sign Up': "S'inscrire",
    Login: 'Connexion',
    'Log In': 'Connexion',
    'License Availability': 'Disponibilité de Licence',
    'My Profile': 'Mon Profil',
    'No description available': 'Pas de description disponible',
    Publications: 'Publications',
    'User Profile': "Profil de l'Utilisateur",
    'New user': 'Nouvel utilisateur',
    'Livox Users Growth': 'Croissance des Utilisateurs de Livox',
    'Users Disability Distribution':
      'Distribution des Utilisateurs par Handicap',
    'Contact us': 'Contactez-nous',
    'Support Type': 'Type de Support',
    Subject: 'Sujet',
    Message: 'Message',
    Send: 'Envoyer',
    'License Distribution': 'Distribution de la Licence',
    'Manage my licenses': 'Gérer mes licences',
    'Show From': 'Afficher de',
    'Only my branch': 'Seulement ma succursale',
    'All Branches': 'Toutes les Succursales',
    'Last Validation Date': 'Date de la Dernière Validation',
    'Device ID': "ID de l'appareil",
    'About you': 'À propos de vous',
    'No publications yet': 'Pas encore de publications',
    'No description available.': 'Pas de description disponible.',
    'Remove this Livox user? ': 'Supprimer cet utilisateur Livox? ',
    'Users by city': 'Utilisateurs par ville',
    'Create new customer': 'Créer un nouveau client',
    'Boards Search': 'Recherche de Tableaux',
    'Add a branch to': 'Ajouter une succursale à',
    'Edit Branch': 'Modifier une Succursale',
    'Edit Customer': 'Modifier le client',
    Update: 'Mettre à jour',
    'Delete Branch': 'Supprimer la succursale',
    'Create Branch Administrator': 'Créer un Administrateur de Succursale',
    'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?':
      'La suppression de cette succursale supprimera les utilisateurs et toutes les licences qui y sont attachés. Êtes-vous sûr de vouloir supprimer cette succursale?',
    'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.':
      'Supprimer cette succursale transférera tous les utilisateurs et licences de cette succursale et de ses succursales filles vers la succursale parente.',
    'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.':
      'Supprimer la succursale racine supprimera les utilisateurs, licences, utilisateurs Livox et titulaires de ce client et de toutes ses succursales.',
    'Are you sure you want to delete this branch?':
      'Êtes-vous sûr de vouloir supprimer cette succursale?',
    'Are you sure you want to delete branch':
      'Êtes-vous sûr de vouloir supprimer la succursale',
    'Delete all users of this customer and all its branches.':
      'Supprimer tous les utilisateurs de ce client et de toutes ses succursales.',
    'Delete all licenses of this customer and all its branches.':
      'Supprimer toutes les licences de ce client et de toutes ses succursales.',
    'Delete all Livox users of this customer and all its branches.':
      'Supprimer tous les utilisateurs Livox de ce client et de toutes ses succursales.',
    'Delete all holders of this customer and all its branches.':
      'Supprimer tous les titulaires de ce client et de toutes ses succursales.',
    'Transfer all users from this branch and its child branches to the parent branch.':
      'Transférer tous les utilisateurs de cette succursale et de ses succursales filles vers la succursale parente.',
    'Transfer all licenses from this branch and its child branches to the parent branch.':
      'Transférer toutes les licences de cette succursale et de ses succursales filles vers la succursale parente.',
    'Remove this branch and its child branch structure.':
      'Supprimer cette succursale et la structure de ses succursales filles.',
    'Reset Password': 'Réinitialiser le Mot de Passe',
    'years ago': 'années auparavant',
    'months ago': 'mois auparavant',
    'days ago': 'jours auparavant',
    'hours ago': 'heures auparavant',
    'minutes ago': 'minutes auparavant',
    'seconds ago': 'secondes auparavant',
    'Livox app is outdated on this device':
      "L'application Livox est obsolète sur cet appareil",
    'Sort By...': 'Trier par...',
    'Device Android Id': "ID Android de l'appareil",
    Saved: 'Enregistré',
    'Saving...': 'Enregistrement...',
    'Error! Please refresh the page.': 'Erreur! Veuillez actualiser la page.',
    Review: 'Revue',
    'Upload an audio or video': 'Télécharger un audio ou une vidéo',
    'All Languages': 'Toutes les langues',
    Portuguese: 'Portugais (Brésil)',
    "By clicking 'Publish' you are agreeing that you have read and accepted our":
      'En cliquant sur "Publier", vous acceptez avoir lu et accepté nos',
    'terms of use': "conditions d'utilisation",
    'Add a shortcut...': 'Ajouter un raccourci...',
    ExampleShortcut:
      'Par exemple: "Que voulez-vous manger?" pour un tableau sur les aliments.',
    'Create voice commands to open this board on Livox app!':
      "Créez des commandes vocales pour ouvrir ce tableau dans l'application Livox!",
    Shortcuts: 'Raccourcis',
    'NEW!': 'NOUVEAU!',
    NEW: 'NOUVEAU',
    'Uploading...': 'Téléchargement...',
    'Processing files...': 'Traitement des fichiers... Veuillez patienter.',
    'The file you uploaded is too large.':
      'Le fichier que vous avez téléchargé est trop volumineux.',
    'Error: File too large': 'Erreur: Fichier trop volumineux',
    'Error: Sorry we just encountered an unexpected error, please try again':
      'Erreur: Désolé, nous avons rencontré une erreur inattendue. Veuillez réessayer',
    'Error: The zip file appears to be corrupted or is not a Livox content':
      "Erreur: Le fichier zip semble être corrompu ou n'est pas un contenu Livox",
    'Are you sure you want to delete this content?':
      'Êtes-vous sûr de vouloir supprimer ce contenu?',
    'Error: Invalid content, please make sure that the file being uploaded is a .zip file':
      'Erreur: Contenu invalide, assurez-vous que le fichier téléchargé est un fichier .zip',
    'Get Started': 'Commencer',
    'Record a new shortcut via voice': 'Enregistrer un nouveau raccourci vocal',
    'You have blocked this website of using the Microphone.':
      "Vous avez bloqué ce site web pour l'utilisation du microphone.",
    "Couldn't detect speech, please check your microphone settings.":
      'Impossible de détecter la parole, veuillez vérifier les paramètres de votre microphone.',
    'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below':
      "Votre navigateur n'est pas compatible avec l'API de reconnaissance vocale, mais vous pouvez entrer manuellement les raccourcis ci-dessous.",
    'Error while recording shortcut, please try again':
      "Erreur lors de l'enregistrement du raccourci, veuillez réessayer.",
    Features: 'Fonctionnalités',
    'Voice Shortcuts': 'Raccourcis Vocaux',
    'Add shortcuts to this folder': 'Ajouter des raccourcis à ce dossier',
    shortcuts: 'raccourcis',
    'You have pending reviews': 'Vous avez des révisions en attente',
    'No pending reviews': 'Aucune révision en attente',
    'Admin Portal': "Portail d'Administration",
    'Log out': 'Se déconnecter',
    'Zip Overwrite': 'Écraser avec Zip',
    Share: 'Partager',
    'Used Licenses': 'Licences Utilisées',
    'Last Registered Activity': 'Dernière Activité Enregistrée',
    'Interactions by time of day': 'Interactions par heure de la journée',
    'Avg. Interactions / User': 'Moy. Interactions / Utilisateur',
    Featured: 'En vedette',
    'Promoted Content': 'Contenu Promu',
    'Rate this': 'Évaluez ceci',
    Promote: 'Promouvoir',
    'Your rating': 'Votre évaluation',
    Play: 'Lire',
    'Back to Edit': "Retour à l'Édition",
    Next: 'Suivant',
    'Inside items': 'Éléments intérieurs',
    Regular: 'Régulier',
    'Book Mode': 'Mode Livre',
    Fixed: 'Fixe',
    System: 'Système',
    Rows: 'Lignes',
    Collumns: 'Colonnes',
    Display: 'Affichage',
    'Page Mode': 'Mode Page',
    'Text Size': 'Taille du Texte',
    Print: 'Imprimer',
    'This dashboard is made with aggregated data across all licenses':
      'Ce tableau de bord est réalisé avec des données agrégées de toutes les licences',
    ' assigned to your user': ' attribuées à votre utilisateur',
    'view licenses': 'voir les licences',
    'No Data': 'Pas de Données',
    'Last 30 days': 'Les 30 derniers jours',
    'Last 6 months': 'Les 6 derniers mois',
    'Last year': "L'année dernière",
    'Results for': 'Résultats pour',
    'Full Screen': 'Plein Écran',
    'Cards cut — navigate and paste into empty slots':
      'Cartes coupées — naviguez et collez dans les espaces vides',
    'No empty slots to paste into': 'Aucun espace vide pour coller',
    'Cards pasted': 'Cartes collées',
    'cards still to paste': 'cartes encore à coller',
    'ready to paste': 'prêt à coller',
    'Paste actions': 'Actions de collage',
    'Cards grouped into folder': 'Cartes regroupées dans un dossier',
    'Select at least 2 cards to group':
      'Sélectionnez au moins 2 cartes à regrouper',
    'New folder': 'Nouveau dossier',
    Cut: 'Couper',
    Copy: 'Copier',
    Paste: 'Coller',
    'Paste Inside': "Coller à l'intérieur",
    Dark: 'Mode Sombre',
    Light: 'Mode Clair',
    'Card Properties': 'Propriétés de la Carte',
    'Export PDF': 'Exporter PDF',
    'Export as PDF': 'Exporter au format PDF',
    'Export section layout': 'Mise en page',
    'Export section content': 'Contenu',
    'Standard layout (grid)': 'Mise en page standard (grille)',
    'Single card (1×1 full page)': 'Carte unique (1×1 pleine page)',
    'Select card to export': 'Sélectionnez la carte à exporter',
    'Select a card': 'Sélectionnez une carte',
    'Current board (grid)': 'Tableau actuel (grille)',
    'Fixed bar only': 'Barre fixe uniquement',
    'Board + Fixed bar': 'Tableau + Barre fixe',
    'Main Board': 'Tableau Principal',
    Part: 'Partie',
    'Cut here': 'Coupez ici',
    'Exported on': 'Exporté le',
    'Fixed Bar': 'Barre Fixe',
    'Cut for continuous use': 'Couper pour un usage continu',
    'Audio / Video': 'Audio / Vidéo',
    'Add an audio or video': 'Ajouter un audio ou une vidéo',
    'Uploaded image': 'Image Téléchargée',
    'On touching this board show this image, if none set it will skip the action':
      "En touchant ce tableau, affichez cette image, si aucune n'est définie, l'action sera ignorée",
    'Search an image': 'Recherche une image',
    Suggestions: 'Suggestions',
    Images: 'Images',
    Publication: 'Publication',
    'Manage Boards': 'Gérer les Tableaux',
    'Livox Web': 'Livox Web',
    'Settings - Display': 'Paramètres - Affichage',
    Start: 'Démarrer',
    Settings: 'Paramètres',
    'Manage Users': 'Gérer les Utilisateurs',
    Voice: 'Voix',
    Controls: 'Contrôles',
    'Artificial Intelligence': 'Intelligence Artificielle',
    About: 'À propos',
    Test: 'Test',
    'Voice Language': 'Langue de la Voix',
    'Voice Actor': 'Acteur de Voix',
    'Voice speed': 'Vitesse de la Voix',
    'Pitch Rate': 'Tonalité de la Voix',
    Preview: 'Aperçu',
    'Quick chat': 'Discussion rapide',
    'Font Size': 'Taille de la Police',
    'Paging Mode': 'Mode Pagination',
    'Touch correction': 'Correction du Toucher',
    'Time to wait between touches': "Temps d'attente entre les touches",
    'Manually set time to prevent any further touches. Set zero seconds to disable.':
      "Définissez manuellement le temps pour éviter d'autres touches. Réglez sur zéro secondes pour désactiver.",
    'Natural Conversation': 'Conversation Naturelle',
    'Trigger words': 'Mots Déclencheurs',
    'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.':
      'Mots-clés enregistrés que Livox écoutera avant de lancer une action. Les mots-clés ne tiennent pas compte de la casse.',
    'No keywords created': 'Aucun mot-clé créé',
    'Speak navigation arrows': 'Parler les flèches de navigation',
    'Enable natural conversation': 'Activer la Conversation Naturelle',
    'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet connection.':
      'Commandes vocales à distance pouvant afficher les tableaux appropriés en fonction du contexte. Nécessite un microphone et une connexion Internet.',
    'Enable Intellitouch': 'Activer Intellitouch',
    'Recommended for users with motor disabilities. Automatically detects imperfect touches.':
      'Recommandé pour les utilisateurs avec des handicaps moteurs. Détecte automatiquement les touches imparfaites.',
    'Delay will be set dynamically by Intellitouch.':
      'Le délai sera réglé dynamiquement par Intellitouch.',
    Legacy: 'Héritage',
    'Livox5+': 'Livox 5.0+',
    'Licenses Status': 'Statut des Licences',
    'Activity days': "Jours d'Activité",
    'Active Usage Status': "Statut d'Utilisation Active",
    'Above Average': 'Au-dessus de la Moyenne',
    'Below Average': 'En-dessous de la Moyenne',
    'Average Interactions': 'Interactions Moyennes : {{clicks}} clics.',
    'Inactive licenses are those in which no user has used Livox in the given period.':
      "Les licences inactives sont celles où aucun utilisateur n'a utilisé Livox pendant la période donnée.",
    'Version Status': 'Statut de la Version',
    'Devices with older Operating System (OS) versions are at risk of losing access to Livox.':
      "Les appareils avec des versions plus anciennes du système d'exploitation risquent de perdre l'accès à Livox.",
    'Outdated OS': 'Système OS Obsolète',
    'Outdated Livox': 'Livox Obsolète',
    'Operational System Version': "Version du Système d'Exploitation",
    'Device usage (%)': "Utilisation de l'appareil (%)",
    'Device usage': "Utilisation de l'appareil",
    'Disability distribution': 'Répartition des Handicaps',
    Period: 'Période',
    '30 days': '30 jours',
    '45 days': '45 jours',
    '2 months': '2 mois',
    '6 months': '6 mois',
    '1 year': '1 an',
    'Global Active Usage': 'Utilisation Active Globale',
    'Percent of the users that used above and below global average ({{clicks}} clicks).':
      "Pourcentage d'utilisateurs ayant utilisé au-dessus et en dessous de la moyenne globale ({{clicks}} clics).",
    'Most Active': 'Le Plus Actif',
    'Least Active': 'Le Moins Actif',
    'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).':
      'Les utilisateurs ayant utilisé 30% au-dessus et en-dessous de votre moyenne (> {{upper_limit}} et < {{lower_limit}} respectivement).',
    'Active users are those that had at least 1 interaction on the time period.':
      'Les utilisateurs actifs sont ceux qui ont eu au moins 1 interaction pendant la période donnée.',
    'Activity ({{days}} days)': 'Activité ({{days}} jours)',
    'Dashboard Charts': 'Graphiques du Tableau de Bord',
    'Users per disability': 'Utilisateurs par Handicap',
    'Users per age': 'Utilisateurs par Âge',
    Autism: 'Autisme',
    'Amyotrophic Lateral Sclerosis': 'Sclérose Latérale Amyotrophique',
    'Cerebral Palsy': 'Paralysie Cérébrale',
    'Person without disabilities': 'Personne sans handicap',
    'No physical disabilities, just unable to speak':
      'Pas de handicap physique, juste incapable de parler',
    'Stroke Sequelae': "Séquelles d'AVC",
    'Down Syndrome': 'Syndrome de Down',
    'Brain Injury': 'Lésion Cérébrale',
    'Another motor impairment': 'Autre handicap moteur',
    'Another cognitive impairment': 'Autre handicap cognitif',
    'Store Statistics': 'Statistiques du Magasin',
    Creators: 'Créateurs',
    Published: 'Publiés',
    'Unique Downloads': 'Téléchargements Uniques',
    Items: 'Éléments',
    'SymbolStyx usage': 'Utilisation de SymbolStix',
    'Uploaded Images': 'Images Téléchargées',
    'Uploaded Audio/Video': 'Audio/Vidéo Téléchargé',
    'Multiple images': 'Images Multiples',
    'Most used symbols': 'Symboles les Plus Utilisés',
    'Usage Status': "Statut d'Utilisation",
    Disclaimer: 'Clause de Non-Responsabilité',
    'basic plan disclaimer':
      "La licence BASIC est une version plus simple de Livox, avec <b>moins de fonctionnalités</b> et <b>sans support technique</b>. Elle est généralement achetée par des parents qui connaissent bien Livox et, par exemple, souhaitent un second appareil avec moins de fonctionnalités pour que leurs enfants l'utilisent en extérieur. <br/> Cette version n'est pas recommandée pour ceux qui commencent à utiliser Livox, mais pour ceux qui ont déjà une version PLUS et souhaitent la BASIC pour un deuxième appareil.",
    'Available Licenses': 'Licences Disponibles',
    'Unable to log in with provided credentials.':
      'Impossible de se connecter avec les informations fournies.',
    'Renew Licenses': 'Renouveler les Licences',
    Border: 'Bordure',
    'It is not possible to access cards with more than one state':
      "Il n'est pas possible d'accéder aux cartes avec plus d'un état",
    'New state': 'Nouvel état',
    'Only text': 'Seulement le texte',
    'Livox IntelliBar (Beta)': 'IntelliBar de Livox (Beta)',
    'Print navigation card': 'Imprimer les cartes de navigation',
    'Board + IntelliBar': 'Tableau + IntelliBar',
    'AI Error': 'Erreur IA :',
    'Create items using AI!':
      "Créez des éléments avec l'Intelligence Artificielle!",
    'Get cards recommendations for every situation!':
      'Recevez des recommandations de cartes pour chaque situation!',
    'Examples:': 'Exemples :',
    'Breakfast items': 'Éléments du petit déjeuner',
    'Teeth brushing steps': 'Étapes pour se brosser les dents',
    'Quiz option choices': "Choix d'options de quiz",
    'and many more!': "et bien d'autres!",
    'Cards suggestion with AI': 'Suggestions de cartes avec IA',
    '{{used}} of {{limit}} used': '{{used}} sur {{limit}} utilisés',
    'Insufficient JandaIA coins': 'Solde de JandaIA Coins insuffisant',
    'Type a topic': 'Saisissez un thème',
    'Add card': 'Ajouter une carte',
    'Card added to board': 'Carte ajoutée au tableau',
    'No empty slots available': 'Aucun emplacement vide disponible',
    'Failed to add card': "Échec de l'ajout de la carte",
    'Print all pages': 'Imprimer toutes les pages',
    "Are you sure you want to delete the card(s)? This can't be undone!":
      'Êtes-vous sûr de vouloir supprimer la/les carte(s)? Cela ne peut pas être annulé!',
    'Edit Email': "Modifier l'E-mail",
    'Already exists an user with informed email':
      'Un utilisateur avec cet e-mail est déjà enregistré',
    'Default Payment': 'Paiement par Défaut',
    'ending with': 'se terminant par',
    'Expires at': 'Expire le',
    'Plan details': 'Détails du Plan',
    "Passwords don't match": 'Les mots de passe ne correspondent pas',
    'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters':
      'Le mot de passe doit contenir au moins une majuscule, une minuscule, un caractère spécial, un chiffre et avoir une longueur minimale de 8 caractères',
    'User Already exists': "L'utilisateur existe déjà",
    'An email will be sent to activate the account':
      'Un e-mail sera envoyé pour activer le compte',
    'Expire month': "Mois d'expiration",
    'Expire year': "Année d'expiration",
    'Select as default payment method':
      'Sélectionner comme méthode de paiement par défaut',
    'Change Billing': 'Modifier la Facturation',
    'Change card details': 'Modifier les détails de la carte',
    activate_license: 'Activer la Licence',
    'Change Livox Plan': 'Changer de Plan Livox',
    'Due next in': 'Prochain paiement dans',
    'Cancel motive': "Motif de l'annulation",
    'Are you sure you want to cancel the plan?':
      'Êtes-vous sûr de vouloir annuler le plan?',
    Card: 'Carte',
    'My subscriptions': 'Mes abonnements',
    Cards: 'Cartes',
    'Welcome to Livox': 'Bienvenue chez Livox',
    'enter your e-mail address': 'entrez votre adresse e-mail',
    'enter your password': 'entrez votre mot de passe',
    'Password requirements': 'Exigences du mot de passe',
    'Must be at least 8 characters long': 'Doit contenir au moins 8 caractères',
    'Must include at least one uppercase letter':
      'Doit inclure au moins une majuscule',
    'Must include at least one lowercase letter':
      'Doit inclure au moins une minuscule',
    'Must include at least one number': 'Doit inclure au moins un chiffre',
    'Must include at least one special character':
      'Doit inclure au moins un caractère spécial',
    'Old Password': 'Ancien Mot de Passe',
    'New Password': 'Nouveau Mot de Passe',
    'enter your old password': 'entrez votre ancien mot de passe',
    'enter your new password': 'entrez votre nouveau mot de passe',
    'confirm your new password': 'confirmez votre nouveau mot de passe',
    'Holder Information': 'Informations du Titulaire',
    Client: 'Client',
    'My Subscriptions': 'Mes Abonnements',
    'Payment Methods': 'Méthodes de Paiement',
    'Payment History': 'Historique des Paiements',
    'Livox Cloud': 'Nuage Livox',
    'of 1TB used': 'sur 1TB utilisés',
    'Portal Livox': 'Portail Livox',
    'CONGRATS!': 'FÉLICITATIONS!',
    'Based on your stats you used your account':
      'Selon vos statistiques, vous avez utilisé votre compte',
    'more than last month!': 'plus que le mois dernier!',
    'Regional Food': 'Cuisine Régionale',
    Animals: 'Animaux',
    'The Flash Game': 'Le Jeu Flash',
    'All users': 'Tous les utilisateurs',
    'All period': 'Toute la période',
    'Last day': 'Le Dernier Jour',
    'Last week': 'La Dernière Semaine',
    'Last month': 'Le Dernier Mois',
    '1 month': '1 mois',
    'User Stats': 'Statistiques des Utilisateurs',
    'Play Games': 'Jouer à des Jeux',
    'Play Duration': 'Durée de Jeu',
    '(minutes)': '(minutes)',
    Recommendations: 'Recommandations',
    'Shared Content': 'Contenu Partagé',
    'Total number of minutes:': 'Nombre total de minutes:',
    'Yes or No': 'Oui ou Non',
    Fruits: 'Fruits',
    Food: 'Nourriture',
    'Monthly Usage': 'Utilisation Mensuelle',
    'Amount of Interactions': "Nombre d'Interactions",
    "Oops! It looks like you haven't shared any content yet.":
      "Oups! On dirait que vous n'avez pas encore partagé de contenu.",
    'Edit Your Profile': 'Modifier Votre Profil',
    Appearance: 'Apparence',
    'Privacy Terms': 'Conditions de Confidentialité',
    'Service Terms': 'Conditions de Service',
    'Password Settings': 'Paramètres de Mot de Passe',
    'For up to 3 users who already know or follow up with Livox professionals.':
      "Pour jusqu'à 3 utilisateurs qui connaissent déjà ou suivent avec des professionnels de Livox.",
    '/MONTH': '/MOIS',
    'Payment Method': 'Méthode de Paiement',
    IntelliTouch: 'IntelliTouch',
    'Image Dataset': "Ensemble d'Images",
    'Current Plan': 'Plan Actuel',
    'Other Subscriptions': 'Autres Abonnements',
    cancel: 'Annuler',
    cpfOrCnpj: 'CPF ou CNPJ',
    processing: 'Traitement en cours...',
    tryAgainIn: 'Réessayez dans {{seconds}}s',
    'BASIC SUBSCRIPTION': 'ABONNEMENT BASIC',
    'Basic Subscription': 'Abonnement Basic',
    'See as list': 'Voir comme liste',
    'See as grid': 'Voir comme grille',
    'HOW IT WORKS?': 'COMMENT ÇA FONCTIONNE?',
    '.zip upload': 'télécharger .zip',
    'create board': 'créer un tableau',
    create: 'créer',
    upload: 'télécharger',
    feedback: "retour d'information",
    'To get started, use Livox Studio to create cards, upload images, music and videos!':
      'Pour commencer, utilisez le Studio Livox pour créer des cartes, télécharger des images, de la musique et des vidéos !',
    'Submit you content to be published in the portal!':
      'Soumettez votre contenu pour être publié sur le portail !',
    'Receive feedback and satisfaction ratings knowing your boards are being used around the world!':
      'Recevez des commentaires et des évaluations de satisfaction en sachant que vos tableaux sont utilisés dans le monde entier !',
    Price: 'Prix',
    OK: 'OK',
    PENDING: 'EN ATTENTE',
    DECLINED: 'REFUSÉ',
    ChangeLivoxPlan: 'Changer le plan Livox',
    'Active Plans': 'Plans actifs',
    'Canceled Plans': 'Plans annulés',
    'Are you sure you want to cancel the plan':
      'Êtes-vous sûr de vouloir annuler le plan ?',
    'Plan changed successfully': 'Plan changé avec succès',
    'Plan cancel successfully': 'Plan annulé avec succès',
    'Provide the reason for cancellation':
      "Fournissez le motif de l'annulation",
    CHANGE: 'CHANGER',
    paid: 'payé',
    open: 'ouvert',
    draft: 'brouillon',
    void: 'nul',
    declined: 'refusé',
    uncollectible: 'irrécouvrable',
    Invoices: 'Factures',
    'Wrong password.': 'Mot de passe incorrect.',
    "The two password fields didn't match.":
      'Les deux champs de mot de passe ne correspondent pas.',
    'Something went wrong.': "Quelque chose s'est mal passé.",
    'Please fill in all required fields.':
      'Veuillez remplir tous les champs obligatoires.',
    'Password changed successfully!': 'Mot de passe changé avec succès!',
    'Device Nickname': "Surnom de l'appareil",
    'License Information': 'Informations sur la Licence',
    to: 'à',
    'Licenses per page': 'Licences par page',
    'Choose a payment method': 'Choisir une méthode de paiement',
    'Published Content': 'Contenu Publié',
    'View published content in the store':
      'Voir les contenus publiés dans le magasin',
    'Payment Method changed successfully':
      'Méthode de paiement changée avec succès',
    'Device removed successfully': 'Appareil supprimé avec succès',
    'Failed to remove device': "Échec de la suppression de l'appareil",
    Monday: 'Lundi',
    Tuesday: 'Mardi',
    Wednesday: 'Mercredi',
    Thursday: 'Jeudi',
    Friday: 'Vendredi',
    Saturday: 'Samedi',
    Sunday: 'Dimanche',
    'Evolution of use': "Évolution de l'utilisation",
    'Use by schedule': 'Utilisation par horaire',
    '(clicks)': '(clics)',
    Responsible: 'Responsable',
    Birthday: 'Date de Naissance',
    Birthdate: 'Date de Naissance',
    None: 'Aucun',
    Mild: 'Léger',
    Moderate: 'Modéré',
    'Severe (Blindness)': 'Sévère (Cécité)',
    Good: 'Bon',
    'Severe (Needs switch)': 'Grave (Nécessite un interrupteur)',
    'Few physical limitations': 'Quelques limitations physiques',
    'Dificulties in daily activities, requires assistance':
      'Difficultés dans les activités quotidiennes, nécessite une assistance',
    'Almost or totally dependent': 'Presque ou totalement dépendant',
    'Without communicative intent': 'Sans intention communicative',
    'Does not verbalize, but has communicative intention':
      'Ne verbalise pas, mais a une intention communicative',
    'Make sounds': 'Émet des sons',
    'Makes vowel unions': 'Fait des unions de voyelles',
    'Speak with very limited vocabulary (5-10 words)':
      'Parle avec un vocabulaire très limité (5-10 mots)',
    'Speak with limited vocabulary (10-30 words)':
      'Parle avec un vocabulaire limité (10-30 mots)',
    'Fully communicative': 'Totalement communicatif',
    'Diagnosis Information': 'Informations sur le Diagnostic',
    'Fine motor skills': 'Habiletés motrices fines',
    'Repetitive movements': 'Mouvements répétitifs',
    'Hearing impairment': 'Déficience auditive',
    'Visual impairment': 'Déficience visuelle',
    'Current communication': 'Communication actuelle',
    'Autonomy level': "Niveau d'autonomie",
    Have: 'A',
    'Does not have': "N'a pas",
    Yes: 'Oui',
    No: 'Non',
    'Customer Admin': 'Admin du Client',
    'Portal Admin': 'Admin du Portail',
    'Users per page': 'Utilisateurs par page',
    Private: 'Privé',
    Organization: 'Organisation',
    'License Usage': 'Utilisation des Licences',
    'Livox Usage': 'Utilisation de Livox',
    Amount: 'Quantité',
    Used: 'Utilisé',
    'Users Status': 'Statut des Utilisateurs',
    'active users': 'utilisateurs actifs',
    Disability: 'Handicap',
    'Portal Users': 'Utilisateurs du Portail',
    'Last Validation': 'Dernière Validation',
    Subscriptions: 'Abonnements',
    'Public?': 'Public?',
    'Avaiable?': 'Disponible?',
    'Searching for boards from all your users':
      'Recherche de tableaux de tous vos utilisateurs',
    'Your filters did not find results':
      "Vos filtres n'ont donné aucun résultat",
    'not found': 'introuvable',
    "It looks like your users haven't created boards yet":
      "Il semble que vos utilisateurs n'ont pas encore créé de tableaux",
    'no boards': 'pas de tableaux',
    'Searching for your boards': 'Recherche de vos tableaux',
    'Find boards created by users in your organization here':
      'Trouvez ici les tableaux créés par les utilisateurs de votre organisation',
    'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?':
      "La suppression de ces appareils déconnectera les utilisateurs de l'application. Êtes-vous sûr de vouloir supprimer {{count}} appareil ?",
    'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?':
      "La suppression de cet appareil déconnectera l'utilisateur de l'application. Êtes-vous sûr de vouloir supprimer cet appareil ?",
    '{{count}} devices removed successfully':
      '{{count}} appareils supprimés avec succès',
    '{{count}} devices failed to be removed':
      "{{count}} appareils n'ont pas pu être supprimés",
    'Branch removed successfully': 'Succursale supprimée avec succès',
    'Failed to remove branch': 'Échec de la suppression de la succursale',
    'Branches moved successfully': 'Succursales déplacées avec succès',
    'Failed to move branches': 'Échec du déplacement des succursales',
    'Move branches to:': 'Déplacer les succursales vers :',
    Move: 'Déplacer',
    'Some selected branches have sub-branches. All sub-branches will also be moved.':
      'Certaines succursales sélectionnées ont des sous-succursales. Toutes les sous-succursales seront également déplacées.',
    'Parent Branch': 'Succursale parente',
    Root: 'Racine',
    'Sub-branch of': 'Sous-succursale de',
    'Branch created successfully!': 'Succursale créée avec succès!',
    'Email already registered': 'E-mail déjà enregistré',
    'Branch updated successfully!': 'Succursale mise à jour avec succès!',
    'Create Branch': 'Créer une Succursale',
    'Update Branch': 'Mettre à jour la Succursale',
    'Edit Publication': 'Modifier la Publication',
    'My Assessments': 'Mes Évaluations',
    'Assessments Details': 'Détails des Évaluations',
    Assessment: 'Évaluation',
    'Assessments per page': 'Évaluations par page',
    Finish: 'Terminer',
    'General assessment': 'Évaluation Générale',
    'Temporal assessment': 'Évaluation Temporelle',
    'Assessment average': 'Moyenne des Évaluations',
    Cognitive: 'Cognitif',
    Auditory: 'Auditif',
    Visual: 'Visuel',
    Oral: 'Oral',
    Behaviour: 'Comportemental',
    Geral: 'Géral',
    'Add comment': 'Ajouter un commentaire',
    'Enter your comment for this assessment':
      'Entrez votre commentaire pour cette évaluation',
    'Assessment added successfully!': 'Évaluation ajoutée avec succès!',
    'Failed to add assessments': "Échec de l'ajout des évaluations",
    'New assessment': 'Nouvelle Évaluation',
    'Customer Support': 'Support Client',
    Promoted: 'Promu',
    Statistics: 'Statistiques',
    Details: 'Détails',
    Refuse: 'Refuser',
    Approve: 'Approuver',
    'Content Details': 'Détails du Contenu',
    'boards per page': 'tableaux par page',
    'Searching for pending content...': 'Recherche de contenu en attente...',
    'Searching for promoted content...': 'Recherche de contenu promu...',
    'Searching for published content...': 'Recherche de contenu publié...',
    Created: 'Créé',
    Demote: 'Rétrograder',
    'Demote Publication': 'Rétrograder la Publication',
    'Do you want to demote this content?':
      'Voulez-vous rétrograder ce contenu?',
    'Approve Publication': 'Approuver la Publication',
    'Do you approve this publication?': 'Approuvez-vous cette publication?',
    'Original language': "Langue d'origine",
    'Translate into (optional)': 'Traduire vers (facultatif)',
    'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.':
      'Le tableau a été rédigé dans cette langue, et non dans celle indiquée lors de l’envoi. Le contenu existant sera réétiqueté, sans être traduit.',
    'Reject Publication': 'Rejeter la Publication',
    'Enter the comment for this rejection':
      'Entrez le commentaire pour ce rejet',
    'Remove Publication': 'Supprimer la Publication',
    'Download count': 'Nombre de téléchargements',
    'Successfully promoted!': 'Promu avec succès!',
    'An error occurred while promoting.':
      "Une erreur s'est produite lors de la promotion.",
    'Upload a banner to promote this board.':
      'Téléchargez une bannière pour promouvoir ce tableau.',
    'Successfully published board!': 'Tableau publié avec succès!',
    'Successfully updated board!!': 'Tableau mis à jour avec succès!',
    'An error occurred while submitting.':
      "Une erreur s'est produite lors de la soumission.",
    'Increase the description to at least 10 characters.':
      'Développez la description pour atteindre au moins 10 caractères.',
    'Publish board': 'Publier le tableau',
    'Board submitted for review!': 'Tableau soumis pour examen !',
    'Please upload a cover image.':
      'Veuillez importer une image de couverture.',
    'The board will be reviewed by an administrator before it appears in the store.':
      'Le tableau sera examiné par un administrateur avant d’apparaître dans la boutique.',
    'Enter description': 'Saisissez une description',
    'Enter title': 'Entrez le titre',
    'Enter subtitle': 'Entrez le sous-titre',
    Subtitle: 'Sous-titre',
    'Email successfully sent!!!': 'E-mail envoyé avec succès!!!',
    'Error sending email!': "Erreur lors de l'envoi de l'e-mail!",
    'The content has been demoted!': 'Le contenu a été rétrogradé!',
    'Failed to demote content!': 'Échec de la rétrogradation du contenu!',
    'Publication successfully approved!': 'Publication approuvée avec succès!',
    'Failed to approve!': "Échec de l'approbation!",
    'Publication successfully rejected!': 'Publication rejetée avec succès!',
    'Failed to reject!': 'Échec du rejet!',
    Activity: 'Activité',
    'License Activity': 'Activité des Licences',
    'Active Licenses': 'Licences Actives',
    'Inactive Licenses': 'Licences Inactives',
    'User Activity': 'Activité des Utilisateurs',
    'Removing this sponsor will revoke access to the dashboard and clear all licenses assigned to them.':
      "La suppression de ce sponsor révoquera l'accès au tableau de bord et effacera toutes les licences qui lui sont attribuées.",
    'Are you sure you want to delete this sponsor?':
      'Êtes-vous sûr de vouloir supprimer ce sponsor?',
    'The sponsor has been deleted!': 'Le sponsor a été supprimé!',
    'Failed to remove sponsor!': 'Échec de la suppression du sponsor!',
    'Sponsor created successfully!': 'Sponsor créé avec succès!',
    'Create Sponsor': 'Créer un Sponsor',
    'enter sponsor name...': 'entrez le nom du sponsor...',
    'enter email...': "entrez l'e-mail...",
    'New Sponsor': 'Nouveau Sponsor',
    Sponsors: 'Sponsors',
    'Projects Details': 'Détails des Projets',
    'Project Dashboard': 'Tableau de Bord du Projet',
    'Sponsors per page': 'Sponsors par page',
    'Assign Licenses': 'Attribuer des Licences',
    '{{count}} licenses successfully assigned':
      '{{count}} licences attribuées avec succès',
    'Failed to assign licenses': "Échec de l'attribution des licences",
    'Assign licenses to sponsor': 'Attribuer des licences au sponsor',
    'Sponsor Licenses': 'Licences du Sponsor',
    'Sponsored Projects': 'Projets Parrainés',
    'Remove Licenses': 'Supprimer les Licences',
    'Remove licenses from sponsor': 'Supprimer les licences du sponsor',
    '{{count}} licenses successfully removed':
      '{{count}} licences supprimées avec succès',
    'Failed to remove licenses': 'Échec de la suppression des licences',
    'Create Portal User': 'Créer un Utilisateur du Portail',
    'enter first name...': 'entrez le prénom...',
    'enter last name...': 'entrez le nom de famille...',
    'enter a password...': 'entrez un mot de passe...',
    'You do not have active plans': "Vous n'avez pas de plans actifs",
    'You do not have canceled plans': "Vous n'avez pas de plans annulés",
    'searching for your payment methods':
      'recherche de vos méthodes de paiement',
    'You have no payment methods': "Vous n'avez aucune méthode de paiement",
    failed: 'échoué',
    'Your token is invalid or has expired':
      'Votre jeton est invalide ou a expiré',
    'Password does not meet the minimum security requirements':
      'Le mot de passe ne répond pas aux exigences minimales de sécurité.',
    'Passwords do not match.': 'Les mots de passe ne correspondent pas.',
    'Resetting...': 'Réinitialisation...',
    'validating your token': 'validation de votre jeton',
    'Password successfully changed!': 'Mot de passe changé avec succès!',
    'Error changing password!': 'Erreur lors du changement de mot de passe!',
    'enter branch name': 'entrez le nom de la succursale',
    'enter branch address': "entrez l'adresse de la succursale",
    'enter customer name': 'entrez le nom du client',
    'enter customer address': "entrez l'adresse du client",
    'enter city': 'entrez la ville',
    'enter zip code': 'entrez le code postal',
    'enter state': "entrez l'état",
    'enter phone number': 'entrez le numéro de téléphone',
    'Unauthorized Access': 'Accès non autorisé',
    'You do not have permission to view this page with your current role.':
      "Vous n'avez pas la permission de voir cette page avec votre rôle actuel.",
    'Page Not Found': 'Page non trouvée',
    'Sorry, the page you are looking for doesn’t exist.':
      "Désolé, la page que vous recherchez n'existe pas.",
    'Este campo não pode ser em branco.': 'Ce champ ne peut pas être vide.',
    'no licenses': 'aucune licence',
    'You do not have any licenses available.':
      "Vous n'avez aucune licence disponible.",
    licenses: 'licences',
    users: 'utilisateurs',
    Quantity: 'Quantité',
    Indicator: 'Indicateur',
    Value: 'Valeur',
    Category: 'Catégorie',
    Aggregate: 'Agréger',
    'Customers per page': 'Clients par page',
    'Holders per page': 'Titulaires par page',
    'Searching for your licenses': 'Recherche de vos licences',
    'There are no promoted boards': "Il n'y a pas de tableaux promus",
    'There are no pending boards': "Il n'y a pas de tableaux en attente",
    'No data was found for this chart.':
      "Aucune donnée n'a été trouvée pour ce graphique.",
    Sponsor: 'Sponsor',
    'My Projects': 'Mes Projets',
    'Invalid Date': 'Date Invalide',
    'Organization Details': "Détails de l'Organisation",
    'All Licenses': 'Toutes les Licences',
    'All License Types': 'Tous les Types de Licence',
    'Select Branch': 'Sélectionner une Succursale',
    'Unlink Licenses': 'Dissocier les Licences',
    'Unlink License': 'Dissocier la Licence',
    'Licenses transferred with success!': 'Licences transférées avec succès!',
    'Error in transfer!': 'Erreur lors du transfert!',
    'An unexpected error occurred!': "Une erreur inattendue s'est produite!",
    'Transfer licenses to:': 'Transférer licences à :',
    'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.':
      'En supprimant cet utilisateur du Portail, il restera disponible sur votre tablette Livox. Si vous ne souhaitez pas que les données de cet utilisateur soient renvoyées au Portail, supprimez-le également de votre tablette.',
    'The Livox User has been deleted!': "L'Utilisateur Livox a été supprimé!",
    'Failed to remove Livox User!':
      "Échec de la suppression de l'Utilisateur Livox!",
    'Delete Livox User': "Supprimer l'Utilisateur Livox",
    'Are you sure you want to delete this livox user?':
      'Êtes-vous sûr de vouloir supprimer cet utilisateur Livox?',
    'Activate with QRCode': 'Activer avec QRCode',
    'Enter a valid holder email': 'Entrez un e-mail de titulaire valide',
    'To activate this license, enter the email of an associated holder.':
      "Pour activer cette licence, entrez l'e-mail d'un titulaire associé.",
    'Holder Email': 'E-mail du Titulaire',
    'Invalid email or not associated with this license.':
      'E-mail invalide ou non associé à cette licence.',
    Validate: 'Valider',
    'Activate with QRCode in your Livox app':
      'Activez avec QRCode dans votre application Livox',
    Distributor: 'Distributeur',
    'Distributor Admin': 'Admin du Distributeur',
    'Distributor Support': 'Support du Distributeur',
    'Create Support Area': 'Créer une Zone de Support',
    'enter support area name...': 'entrez le nom de la zone de support...',
    'Support area created successfully!': 'Zone de support créée avec succès!',
    'Removing this support area will only unlink customers and users from this area.':
      'La suppression de cette zone de support ne fera que dissocier les clients et utilisateurs de cette zone.',
    'Are you sure you want to delete this support area?':
      'Êtes-vous sûr de vouloir supprimer cette zone de support?',
    'The support area has been deleted!': 'La zone de support a été supprimée!',
    'Failed to remove support area!':
      'Échec de la suppression de la zone de support!',
    'Support Area Users': 'Utilisateurs de la Zone de Support',
    'Remove Users': 'Supprimer Utilisateurs',
    'Remove users from support area':
      'Supprimer les utilisateurs de la zone de support',
    'Failed to remove users': 'Échec de la suppression des utilisateurs',
    'Select Users': 'Sélectionner Utilisateurs',
    '{{count}} users successfully removed':
      '{{count}} utilisateurs supprimés avec succès',
    'Support Area Customers': 'Clients de la Zone de Support',
    'Select Customers': 'Sélectionner Clients',
    'Customers added successfully!': 'Clients ajoutés avec succès!',
    'Remove Customers': 'Supprimer Clients',
    '{{count}} customers successfully removed':
      '{{count}} clients supprimés avec succès',
    'Failed to remove customers': 'Échec de la suppression des clients',
    'Remove customers from support area':
      'Supprimer les clients de la zone de support',
    Add: 'Ajouter',
    'Support Areas per page': 'Zones de Support par page',
    'Created at': 'Créé le',
    'Confirm delete': 'Confirmer la suppression',
    'Android Versions': 'Versions Android',
    'Create Android Version': 'Créer une version Android',
    'Edit Android Version': 'Modifier la version Android',
    'New Android Version': 'Nouvelle version Android',
    'Android version created successfully!':
      'Version Android créée avec succès!',
    'Android version updated successfully!':
      'Version Android mise à jour avec succès!',
    'The android version has been deleted!':
      'La version Android a été supprimée!',
    'Failed to remove android version!':
      'Échec de la suppression de la version Android!',
    'Are you sure you want to delete this android version?':
      'Êtes-vous sûr de vouloir supprimer cette version Android?',
    'Android Versions per page': 'Versions Android par page',
    Resellers: 'Revendeurs',
    'Create Reseller': 'Créer un revendeur',
    'Edit Reseller': 'Modifier le revendeur',
    'New Reseller': 'Nouveau revendeur',
    'enter reseller name...': 'entrez le nom du revendeur...',
    'Reseller created successfully!': 'Revendeur créé avec succès!',
    'Reseller updated successfully!': 'Revendeur mis à jour avec succès!',
    'The reseller has been deleted!': 'Le revendeur a été supprimé!',
    'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.':
      "Impossible de supprimer le revendeur. Assurez-vous qu'il n'y a pas de licences associées avant de le supprimer.",
    'Are you sure you want to delete this reseller?':
      'Êtes-vous sûr de vouloir supprimer ce revendeur?',
    'Resellers per page': 'Revendeurs par page',
    'Payment QR Code': 'QR Code de paiement',
    'Payment link for {{name}}': 'Lien de paiement pour {{name}}',
    'Payment link': 'Lien de paiement',
    'User created successfully!': 'Utilisateur créé avec succès!',
    French: 'Français',
    Italian: 'Italien',
    Spanish: 'Espagnol',
    'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.':
      "Notre site web a été mis à jour pour améliorer votre expérience. Pour garantir un bon fonctionnement, nous vous recommandons de vider le cache de votre navigateur. Si vous utilisez la version 5 de l'application Livox, veuillez fermer et rouvrir l'application pour assurer la connexion correcte à votre compte.",
    'Website Update': 'Mise à jour du site web',
    'Reload page': 'Recharger la page',
    "Don't show again": 'Ne plus afficher',
    'enter email': "entrez l'e-mail",
    'Customer created successfully!': 'Customer created successfully!',
    'Enter a valid email address': 'Enter a valid email address',
    'Only letters are allowed': 'Only letters are allowed',
    'enter number of devices': 'enter number of devices',
    'enter text': 'enter text',
    'enter install key...': "entrez la clé d'installation...",
    'enter device name...': "entrez le nom de l'appareil...",
    'enter device nickname...': "entrez le surnom de l'appareil...",
    'enter device MAC address...': "entrez l'adresse MAC de l'appareil...",
    'Device MAC Address': "Adresse MAC de l'Appareil",
    'Licenses created successfully!': 'Licences créées avec succès!',
    Payment: 'Paiement',
    'Registration link generated successfully!':
      'Link de registre généré avec succès!',
    'Failed to generate registration link.':
      "Échec de la génération du lien d'inscription.",
    'Copy Link': 'Copier le Lien',
    'Link copied to clipboard!': 'Lien copié dans le presse-papiers!',
    '{{diff}} year(s) ago': 'il y a {{diff}} an(s)',
    '{{diff}} month(s) ago': 'il y a {{diff}} mois',
    '{{diff}} day(s) ago': 'il y a {{diff}} jour(s)',
    '{{diff}} hour(s) ago': 'il y a {{diff}} heure(s)',
    '{{diff}} minute(s) ago': 'il y a {{diff}} minute(s)',
    'Holder registered successfully!': 'Titulaire enregistré avec succès!',
    'Register Holder': 'Enregistrer le Titulaire',
    'enter address': "entrez l'adresse",
    'confirm your password': 'confirmez votre mot de passe',
    'Passwords must match': 'Les mots de passe doivent correspondre',
    'Professional Type': 'Type de Professionnel',
    'Speech Therapist': 'Orthophoniste',
    'Occupational Therapist': 'Ergothérapeute',
    Physiotherapist: 'Kinésithérapeute',
    Teacher: 'Enseignant',
    Pedagogue: 'Pédagogue',
    Psychopedagogue: 'Psychopédagogue',
    Other: 'Autre',
    'Error loading subscription details':
      "Erreur lors du chargement des détails de l'abonnement",
    Activation: 'Activation',
    Cancellation: 'Annulation',
    'Due Date': "Date d'échéance",
    'Payment Link': 'Lien de paiement',
    Receipt: 'Reçu',
    'View Receipt': 'Voir le reçu',
    'Invoice Date': 'Date de la facture',
    Paid: 'Payé',
    'Invoice Status': 'Statut de la facture',
    'Receipt Link': 'Lien du reçu',
    'Status updated successfully': 'Statut mis à jour avec succès',
    'Failed to update license status': 'Échec de la mise à jour du statut',
    'Edit License': 'Modifier la Licence',
    'Are you sure you want to delete this license?':
      'Êtes-vous sûr de vouloir supprimer cette licence?',
    'Are you sure you want to delete license':
      'Êtes-vous sûr de vouloir supprimer la licence',
    'This will delete all licenses with install key: {{installKey}}':
      "Cela supprimera toutes les licences avec la clé d'installation: {{installKey}}",
    'Permanently delete the license(s)':
      'Supprimer définitivement la(les) licence(s)',
    'License deleted successfully!': 'Licence supprimée avec succès!',
    'Failed to delete license!': 'Échec de la suppression de la licence!',
    'License updated successfully!': 'Licence mise à jour avec succès!',
    'Failed to update license!': 'Échec de la mise à jour de la licence!',
    'No changes to save': 'Aucun changement à enregistrer',
    'Are you sure you want to update all licenses?':
      'Êtes-vous sûr de vouloir mettre à jour toutes les licences?',
    'This will update all licenses with install key':
      "Cela mettra à jour toutes les licences avec la clé d'installation",
    'Update install key to': "Mettre à jour la clé d'installation vers",
    'Update type to': 'Mettre à jour le type vers',
    'All licenses with this install key will be affected!':
      "Toutes les licences avec cette clé d'installation seront affectées!",
    'Click here': 'Cliquez ici',
    Donation: 'Donation',
    Sale: 'Vente',
    Evaluation: 'Évaluation',
    Research: 'Recherche',
    'Old Version (BETA TEST)': 'Ancienne Version (TEST BETA)',
    Developer: 'Développeur',
    Representative: 'Représentant',
    'Resale Channel': 'Canal de revente',
    'Are you sure you want to unblock this customer?':
      'Êtes-vous sûr de vouloir débloquer ce client?',
    'Are you sure you want to block this customer?':
      'Êtes-vous sûr de vouloir bloquer ce client?',
    Block: 'Bloquer',
    'Change Status': 'Changer le statut',
    'Are you sure you want to change the status?':
      'Êtes-vous sûr de vouloir changer le statut?',
    Select: 'Sélectionner',
    'Unit manager': "Gestionnaire d'unité",
    'type to search': 'tapez pour rechercher',
    'Manager e-mail': 'E-mail du gestionnaire',
    'Create user': 'Créer un utilisateur',
    'Cancel user creation': "Annuler la création d'utilisateur",
    'Select existing user': 'Sélectionner un utilisateur existant',
    'enter password': 'saisir le mot de passe',
    'confirm password': 'confirmer le mot de passe',
    'Select a manager or create a new user':
      'Sélectionnez un gestionnaire ou créez un nouvel utilisateur',
    'Email not found. Click Create user':
      'E-mail non trouvé. Cliquez sur Créer un utilisateur',
    'This email already exists. Select an existing user':
      'Cet e-mail existe déjà. Sélectionnez un utilisateur existant',
    'Customer email already registered.':
      "L'e-mail du client est déjà enregistré.",
    'Email is required': 'E-mail est obligatoire',
    'Invalid value': 'Valeur invalide',
    'This field is required': 'Ce champ est obligatoire',
    'Password is required': 'Mot de passe est obligatoire',
    'Confirm Exit': 'Confirmer la sortie',
    'Are you sure you want to exit? Any unsaved changes will be lost.':
      'Êtes-vous sûr de vouloir quitter? Toutes les modifications non enregistrées seront perdues.',
    Export: 'Exporter',
    'Export Charts': 'Exporter les Graphiques',
    'Export Charts to PDF': 'Exporter les Graphiques en PDF',
    'Export Data': 'Exporter les Données',
    'Exporting...': 'Exportation en cours...',
    'No data to export': 'Aucune donnée à exporter',
    'No charts found to export': 'Aucun graphique trouvé à exporter',
    'File exported successfully': 'Fichier exporté avec succès',
    'Charts exported successfully': 'Graphiques exportés avec succès',
    'Export successful!': 'Exportation réussie!',
    'Export failed!': 'Échec de l’exportation!',
    'Error exporting file': "Erreur lors de l'exportation du fichier",
    'Error exporting charts': "Erreur lors de l'exportation des graphiques",
    'Are you sure you want to delete this user?':
      'Êtes-vous sûr de vouloir supprimer cet utilisateur?',
    'Are you sure you want to delete user':
      "Êtes-vous sûr de vouloir supprimer l'utilisateur",
    'This action will:': 'Cette action:',
    'Unlink all licenses from the user holder':
      "Déliera toutes les licences du titulaire de l'utilisateur",
    'Delete the associated holder (if exists)':
      'Supprimera le titulaire associé (si existe)',
    'Remove user from all groups': "Retirera l'utilisateur de tous les groupes",
    'Delete all Livox Users linked to this user':
      'Supprimera tous les Utilisateurs Livox liés à cet utilisateur',
    'Permanently delete the user account':
      "Supprimera définitivement le compte de l'utilisateur",
    'This action cannot be undone!': 'Cette action ne peut pas être annulée!',
    'User updated successfully!': 'Utilisateur mis à jour avec succès!',
    'User deleted successfully!': 'Utilisateur supprimé avec succès!',
    '{{count}} licenses unlinked.': '{{count}} licences déliées.',
    'Holder deleted.': 'Titulaire supprimé.',
    'Failed to delete user!': "Échec de la suppression de l'utilisateur!",
    'Changing password for user':
      "Changement de mot de passe pour l'utilisateur",
    'enter new password...': 'entrez le nouveau mot de passe...',
    'confirm new password...': 'confirmez le nouveau mot de passe...',
    'Update Password': 'Mettre à Jour le Mot de Passe',
    'Password updated successfully!': 'Mot de passe mis à jour avec succès!',
    'confirm your password...': 'confirmez votre mot de passe...',
    'Edit Portal User': "Modifier l'Utilisateur du Portail",
    'User Details': "Détails de l'Utilisateur",
    'Personal Data': 'Données Personnelles',
    'View Details': 'Voir les Détails',
    'View Holder Details': 'Voir les Détails du Titulaire',
    'View Boards': 'Voir les Tableaux',
    'View Content Store': 'Voir le Magasin de Contenus',
    'Created boards': 'Tableaux créés',
    Total: 'Total',
    'Published boards': 'Tableaux publiés',
    'No holder linked': 'Aucun titulaire lié',
    'No customer linked': 'Aucun client lié',
    'User Boards': 'Tableaux Utilisateur',
    'View boards created by this user':
      'Voir les tableaux créés par cet utilisateur',
    'Customer not found': 'Client non trouvé',
    'Loading boards': 'Chargement des tableaux',
    "This user hasn't created any boards yet":
      "Cet utilisateur n'a pas encore créé de tableaux",
    'Create Holder': 'Créer un Titulaire',
    'Edit Holder': 'Modifier le Titulaire',
    'Holder created successfully!': 'Titulaire créé avec succès!',
    'No user found for this email. Fill in the fields below to create a new holder user.':
      'Aucun utilisateur trouvé pour cet e-mail. Remplissez les champs ci-dessous pour créer un nouvel utilisateur titulaire.',
    'Holder updated successfully!': 'Titulaire mis à jour avec succès!',
    'Holder deleted successfully!': 'Titulaire supprimé avec succès!',
    'Are you sure you want to delete this holder?':
      'Êtes-vous sûr de vouloir supprimer ce titulaire?',
    'Are you sure you want to delete holder':
      'Êtes-vous sûr de vouloir supprimer le titulaire',
    'Release all licenses from this holder':
      'Libérer toutes les licences de ce titulaire',
    'Permanently delete the holder': 'Supprimer définitivement le titulaire',
    '{{count}} licenses released.': '{{count}} licences libérées.',
    'Failed to delete holder!': 'Échec de la suppression du titulaire!',
    'User is required': "L'utilisateur est obligatoire",
    'Country is required': 'Le pays est obligatoire',
    'Zipcode is required': 'Le code postal est obligatoire',
    'Phone number is required': 'Le numéro de téléphone est obligatoire',
    'enter zipcode...': 'entrez le code postal...',
    'enter address...': "entrez l'adresse...",
    'enter city...': 'entrez la ville...',
    'enter state...': "entrez l'état...",
    'enter phone number...': 'entrez le numéro de téléphone...',
    'enter professional record...': 'entrez le registre professionnel...',
    'Professional Record': 'Registre Professionnel',
    'Holder Details': 'Détails du Titulaire',
    'Professional Information': 'Informations Professionnelles',
    'No licenses linked': 'Aucune licence liée',
    'Livox User Details': "Détails de l'Utilisateur Livox",
    'Personal Information': 'Informations Personnelles',
    'Health Information': 'Informations de Santé',
    'Contact Information': 'Informations de Contact',
    'Responsible Information': 'Informations du Responsable',
    'Responsible 1 Name': 'Nom du Responsable 1',
    'Responsible 1 Email': 'E-mail du Responsable 1',
    'Responsible 1 Phone': 'Téléphone du Responsable 1',
    'Responsible 2 Name': 'Nom du Responsable 2',
    'Responsible 2 Email': 'E-mail du Responsable 2',
    'Responsible 2 Phone': 'Téléphone du Responsable 2',
    'Autonomy Level': "Niveau d'Autonomie",
    'Current Communication': 'Communication Actuelle',
    'Visual Impairment': 'Déficience Visuelle',
    'Fine Motor Skills': 'Habiletés Motrices Fines',
    'Repetitive Movements': 'Mouvements Répétitifs',
    'Hearing Impairment': 'Déficience Auditive',
    'No data available': 'Aucune donnée disponible',
    'Edit Livox User': "Modifier l'Utilisateur Livox",
    Unauthorized: 'Non autorisé',
    'Board settings': 'Paramètres du tableau',
    'Board name and cover': 'Nom et couverture du tableau',
    'Board name': 'Nom du tableau',
    'Board cover image': 'Image de couverture du tableau',
    'Board cover': 'Couverture du tableau',
    'Click the image to change': "Cliquez sur l'image pour changer",
    'Error uploading image': "Erreur lors du téléchargement de l'image",
    'Error saving title': 'Erreur lors de la sauvegarde du nom',
    'Move cards': 'Déplacer les cartes',
    'Select cards': 'Sélectionner les cartes',
    Redo: 'Rétablir',
    Help: 'Aide',
    Layout: 'Mise en page',
    'Board background color': 'Couleur de fond du tableau',
    'Card settings': 'Paramètres des cartes',
    'Fixed bar settings': 'Paramètres de la barre fixe',
    'Lock board horizontal': 'Verrouiller le tableau horizontalement',
    'Auto navigation cards': 'Cartes de navigation automatique',
    back: 'retour',
    Columns: 'Colonnes',
    'Select background color': 'Sélectionner la couleur de fond',
    'General card settings': 'Paramètres généraux des cartes',
    'Show text only': 'Afficher uniquement le texte',
    'Text position': 'Position du texte',
    Bottom: 'Bas',
    Top: 'Haut',
    'Show cards with levels as folders':
      'Afficher les cartes à niveaux sous forme de dossiers',
    'High contrast cards': 'Cartes à fort contraste',
    'Black and white cards': 'Cartes en noir et blanc',
    IntelliBar: 'IntelliBar',
    'Enable IntelliBar': 'Activer IntelliBar',
    'IntelliBar description':
      "Lorsqu'elle est activée, Livox affiche une barre en haut de l'écran où l'utilisateur peut créer des phrases. Cette fonctionnalité nécessite le téléchargement du tableau de cartes de conversation IntelliBar si ce n'est pas déjà fait.",
    'IntelliBar screen size': "Taille d'IntelliBar à l'écran",
    'Speak card when adding to IntelliBar':
      'Lire la carte lors de l’ajout à IntelliBar',
    Disabled: 'Désactivé',
    Enabled: 'Activé',
    'Partially enabled': 'Partiellement activé',
    intelibar_speak_disabled_desc:
      "Livox ne parlera qu'en appuyant sur le bouton parler de l'IntelliBar.",
    intelibar_speak_partial_desc:
      "Livox prononcera la carte cliquée insérée dans l'IntelliBar.",
    intelibar_speak_full_desc: 'Livox prononcera toutes les cartes cliquées.',
    'Speak card before adding': 'Lire la carte avant d’ajouter',
    'Speak card after adding': 'Lire la carte après avoir ajouté',
    'Show only card text in IntelliBar':
      'Afficher uniquement le texte de la carte dans IntelliBar',
    'Enable fixed bar': 'Activer la barre fixe',
    'Fixed bar scroll up': 'Faire défiler la barre fixe vers le haut',
    'Fixed bar scroll down': 'Faire défiler la barre fixe vers le bas',
    'Fixed bar scroll left': 'Faire défiler la barre fixe vers la gauche',
    'Fixed bar scroll right': 'Faire défiler la barre fixe vers la droite',
    'Fixed bar limit reached': 'Limite de la barre fixe atteint',
    Position: 'Position',
    Side: 'Latéral',
    'Visible cards count': 'Nombre de cartes visibles',
    'Show as folder': 'Afficher en dossier',
    'Select card bar color': 'Sélectionner la couleur de la barre des cartes',
    'Create a Card': 'Créer une carte',
    Image: 'Image',
    'Text/Spoken text': 'Texte / texte parlé',
    'Color Background': 'Couleur de fond',
    'Add media': 'Ajouter un média',
    'Image Bank': "Banque d'images",
    'Search image': 'Rechercher une image',
    'Starts with': 'Commence par',
    'Card title': 'Titre de la carte',
    'Spoken Text': 'Texte parlé',
    'Letters; Numbers': 'Lettres ; chiffres',
    'Text/Spoken Text': 'Texte / Texte parlé',
    card_title_description: 'Ce texte sera affiché sur la carte.',
    'Spoken text': 'Texte parlé',
    spoken_text_description:
      'Ce texte sera lu. Vous pouvez écrire de longs textes si vous le souhaitez.',
    'Text font': 'Police du texte',
    'Text color': 'Couleur du texte',
    'Background Color': 'Couleur de fond',
    'Background color card': 'Couleur de fond de la carte',
    'Card border color': 'Couleur de la bordure de la carte',
    'Attach a media': 'Joindre un média',
    'No media': 'Aucun média',
    'Record an audio': 'Enregistrer un audio',
    'Pick an audio': 'Choisir un audio',
    'Pick a video': 'Choisir une vidéo',
    'Cards Properties': 'Propriétés des cartes',
    'Show just text': 'Afficher uniquement le texte',
    show_just_text_desc:
      'Si activé, Livox n’affichera plus les cartes avec image',
    'Large size images': 'Images en grande taille',
    large_images_desc: 'Si activé, les cartes apparaîtront plus grandes',
    'Keep the card unchanged': 'Conserver la carte inchangée',
    keep_unchanged_desc:
      'Cette carte ne sera pas modifiée sur les tableaux aux valeurs par défaut',
    'Display card in folder format': 'Afficher la carte en format dossier',
    'Card Title': 'Titre de la carte',
    'Upload Card': 'Téléverser une carte',
    'Board layout': 'Disposition du tableau',
    'Maintain relative positioning': 'Conserver le positionnement relatif',
    help_move:
      'Activez pour faire glisser et réorganiser les cartes sur le tableau.',
    help_select: 'Activez pour sélectionner plusieurs cartes à la fois.',
    help_yesno: 'Activez pour ajouter des boutons Oui/Non sur les cartes.',
    help_undo_redo: 'Annuler ou rétablir les modifications des paramètres.',
    help_play_mode:
      "Ouvre le tableau en plein écran pour l'utiliser réellement : naviguez dans les cartes et dossiers, composez des phrases et écoutez-les.",
    help_export_pdf:
      'Exporte le tableau actuel au format PDF pour l’imprimer ou le partager.',
    help_ia:
      "Utilisez l'intelligence artificielle pour suggérer des cartes automatiquement.",
    'Card actions': 'Actions de la carte',
    Interests: 'Intérêts',
    'Android ID': 'Android ID',
    'Advanced Filters': 'Filtres Avancés',
    'Apply Filters': 'Appliquer les Filtres',
    'Clear All': 'Tout Effacer',
    Order: 'Trier',
    Ascending: 'Croissant',
    Descending: 'Décroissant',
    From: 'De',
    To: 'À',
    All: 'Tous',
    Information: 'Informations',
    Location: 'Emplacement',
    Keys: 'Clés',
    'Date of Birth': 'Date de Naissance',
    'Activated Licenses': 'Licences Activées',
    'Inactivated Licenses': 'Licences Désactivées',
    Options: 'Options',
    Hide: 'Masquer',
    Show: 'Afficher',
    'Enter sublevel': 'Entrer dans le sous-niveau',
    'Create folder': 'Créer un dossier',
    'Edit Card': 'Modifier la carte',
    'Add state': 'Ajouter un état',
    'Cannot access cards with more than one state':
      "Impossible d'accéder aux cartes ayant plus d'un état.",
    'Cards with sublevels cannot have multiple states':
      'Les cartes avec sous-niveaux ne peuvent pas avoir plusieurs états.',
    Untitled: 'Sans titre',
    'No states yet. Add one below.':
      "Pas encore d'états. Ajoutez-en un ci-dessous.",
    'Generate image': 'Générer une image',
    'Enter image prompt...': "Saisir une description d'image...",
    'Image style': "Style d'image",
    'Download image': "Télécharger l'image",
    Contains: 'Contient',
    'Type to search symbols': 'Tapez pour chercher des symboles',
    'Save failed': 'Échec de la sauvegarde',
    'Choose file from computer': "Choisir un fichier depuis l'ordinateur",
    Upload: 'Télécharger',
    'Upload failed': 'Échec du téléchargement',
    'Select from image bank': "Sélectionner dans la banque d'images",
    'Generate with AI': 'Générer avec IA',
    Generated: 'Générée',
    'Upload an image from your device':
      'Téléversez une image depuis votre appareil',
    'Choose a symbol from the image bank':
      "Choisissez un symbole dans la banque d'images",
    Selected: 'Sélectionné',
    'Unsaved image selected': 'Image non sauvegardée sélectionnée',
    'Upload image from computer': "Télécharger une image depuis l'ordinateur",
    'Select an image before saving the card.':
      "Sélectionnez une image avant d'enregistrer la carte.",
    'Book Settings': 'Paramètres du livre',
    'Text size': 'Taille du texte',
    'Highlight spoken text': 'Surligner le texte lu',
    Exit: 'Quitter',
    'Start over': 'Recommencer depuis le début',
    'To enable Book Mode, add cards to the board':
      'Pour activer le mode livre, ajoutez des cartes au tableau',
    'Deactivate Book Mode to create sublevels':
      'Désactivez le mode livre pour créer des sous-niveaux',
    'Continue from page {{page}}': 'Continuer à partir de la page {{page}}',
    'Open at page {{page}}': 'Ouvrir à la page {{page}}',
    'To enable Book Mode, add child cards':
      'Pour activer le mode livre, ajoutez des cartes enfants',
    'This book has no pages': "Ce livre n'a pas de pages",
  },
}
